import {CustomerManageDetail} from "@/features/manage";

import {vars} from "@/shared/lib";
import {Column, Indicator} from "@/shared/ui";
import {createFileRoute} from "@tanstack/react-router";
import {Suspense} from "react";

export const Route = createFileRoute("/(auth)/_layout/manage/customer-manage/$customerManageId/")({
	component: CustomerManageRegisterDetailPage
});

function CustomerManageRegisterDetailPage() {
	return (
		<Column fullWidth style={{gap: vars.size[16]}}>
			<Suspense fallback={<Indicator />}>
				<CustomerManageDetail />
			</Suspense>
		</Column>
	);
}
